import { ICommonMaster } from "../../models/common_master";
export const transformFromMasterToCSV = <T extends ICommonMaster>(data: T) => {
  if (`description` in data) {
    return {
      id: data.id,
      name: data.name,
      description: data.description,
    };
  } else {
    return {
      id: data.id,
      name: data.name,
    };
  }
};
